import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';

// Tes imports de pages
import Landing from './Landing';
import LandingAI from './LandingAI'; // 👈 C'EST LUI QUI MANQUAIT PEUT-ÊTRE !
import Dashboard from './Dashboard';
import Audit from './Audit';
import Score from './Score';
import AssistantIA from './AssistantIA';
import Pricing from './Pricing';
import Register from './Register';
import Login from './Login';
import MotDePasseOublie from './MotDePasseOublie';
import ReinitialiserMotDePasse from './ReinitialiserMotDePasse';
import Parametres from './Parametres';
import Footer from './Footer';
import Blog from './Blog';
import BlogArticleRgpdNis2Iso27001 from './BlogArticleRgpdNis2Iso27001';
import BlogArticleCybersecuritePME from './BlogArticleCybersecuritePME';
import BlogArticleQuiEstConcerneNIS2 from './BlogArticleQuiEstConcerneNIS2';
import BlogArticleAuditDiagnosticPME from './BlogArticleAuditDiagnosticPME';
import BlogArticleDiagnosticAQuoiSattendre from './BlogArticleDiagnosticAQuoiSattendre';
import BlogArticleCommentEvaluer from './BlogArticleCommentEvaluer';
import BlogArticleChecklistCybersecurite from './BlogArticleChecklistCybersecurite';
import BlogArticleSecuriteDonneesRGPD from './BlogArticleSecuriteDonneesRGPD';
import BlogArticleGestionDesRisques from './BlogArticleGestionDesRisques';
import BlogArticleNIS2PMEChangements from './BlogArticleNIS2PMEChangements';
import BlogArticleISO27001PMEAccessible from './BlogArticleISO27001PMEAccessible';
import BlogArticleRansomware from './BlogArticleRansomware';
import BlogArticlePhishing from './BlogArticlePhishing';
import BlogArticleQueFaireApresCyberattaque from './BlogArticleQueFaireApresCyberattaque';
import BlogArticleErreursFrequentes from './BlogArticleErreursFrequentes';
import BlogArticleSecuriteInformatiqueFondamentaux from './BlogArticleSecuriteInformatiqueFondamentaux';
import BlogArticleRGPDPilier from './BlogArticleRGPDPilier';
import BlogArticleViolationDonnees from './BlogArticleViolationDonnees';
import BlogArticleAuditRGPD from './BlogArticleAuditRGPD';
import BlogArticleAuditNIS2 from './BlogArticleAuditNIS2';
import BlogArticleIAPilier from './BlogArticleIAPilier';
import BlogArticleRisquesIAPanorama from './BlogArticleRisquesIAPanorama';
import BlogArticleGouvernanceIA from './BlogArticleGouvernanceIA';
import BlogArticleRisquesDonneesIA from './BlogArticleRisquesDonneesIA';
import BlogArticleAIActCybersecurite from './BlogArticleAIActCybersecurite';
import BlogArticleAttaquesSystemesIA from './BlogArticleAttaquesSystemesIA';
import BlogArticlePromptInjection from './BlogArticlePromptInjection';
import BlogArticleFuiteDonneesSystemesIA from './BlogArticleFuiteDonneesSystemesIA';
import BlogArticleSecuriteAPIModelesIA from './BlogArticleSecuriteAPIModelesIA';
import BlogArticleGestionFournisseursIA from './BlogArticleGestionFournisseursIA';
import BlogArticleEvaluerRisquesIA from './BlogArticleEvaluerRisquesIA';
import BlogArticleIntegrerIAISO27001 from './BlogArticleIntegrerIAISO27001';
import BlogArticleIARGPDNIS2Articuler from './BlogArticleIARGPDNIS2Articuler';
import BlogArticleSupervisionUsagesIA from './BlogArticleSupervisionUsagesIA';

// 🎨 IMPORT DE TON NOUVEAU LOGO
import logo from './logo.png'; // Ou logo.jpg selon ton fichier

// --- PROTECTION DES ROUTES ---
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

// --- GESTION DU FOOTER ---
const FooterWrapper = () => {
  const location = useLocation();
  // On affiche le footer sur la Landing classique ET sur la Landing IA
  return location.pathname === '/' || location.pathname === '/ai-act' || location.pathname.startsWith('/blog') ? <Footer /> : null;
};

function App() {

  const EN_MAINTENANCE = false;

  if (EN_MAINTENANCE) {
    return (
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#0B1F3A', color: 'white', fontFamily: '"Inter", sans-serif', textAlign: 'center', padding: '20px' }}>
        <span style={{ fontSize: '80px', marginBottom: '20px' }}>🚧</span>
        <h1 style={{ fontSize: '40px', fontWeight: 'bold', margin: '0 0 15px 0' }}>Mise à jour de sécurité en cours</h1>
      </div>
    );
  }

  return (
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: 'Arial, sans-serif' }}>

        {/* BARRE DE NAVIGATION */}
        <nav style={{ background: '#2c3e50', padding: '15px' }}>
          <ul style={{ listStyle: 'none', display: 'flex', gap: '20px', margin: 0, padding: 0, alignItems: 'center' }}>
            <li>
              <Link to="/">
                <img src={logo} alt="Audit Cyber Pro Logo" style={{ height: '40px', cursor: 'pointer', marginRight: '10px' }} />
              </Link>
            </li>
            <li><Link to="/" style={{ color: 'white', textDecoration: 'none', fontWeight: 'bold' }}>Accueil</Link></li>
            <li><Link to="/blog" style={{ color: 'white', textDecoration: 'none' }}>Blog</Link></li>
            <li><Link to="/dashboard" style={{ color: 'white', textDecoration: 'none' }}>Dashboard</Link></li>
            <li><Link to="/parametres" style={{ color: 'white', textDecoration: 'none' }}>Paramètres</Link></li>
            <li style={{ marginLeft: 'auto' }}>
              <Link to="/login" style={{ color: 'white', textDecoration: 'none', padding: '8px 15px', border: '1px solid white', borderRadius: '5px' }}>Connexion</Link>
            </li>
          </ul>
        </nav>

        {/* CONTENU PRINCIPAL */}
        <div style={{ flex: 1 }}>
          <Routes>
            {/* 🗺️ LES ROUTES SONT ICI */}
            <Route path="/" element={<Landing />} />
            <Route path="/ai-act" element={<LandingAI />} /> {/* 👈 LA DIRECTION VERS LA PAGE IA EST LÀ ! */}
            <Route path="/login" element={<Login />} />
            <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
            <Route path="/reinitialiser-mot-de-passe" element={<ReinitialiserMotDePasse />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/rgpd-nis2-iso27001-differences" element={<BlogArticleRgpdNis2Iso27001 />} />
            <Route path="/blog/cybersecurite-pme-guide-dirigeants" element={<BlogArticleCybersecuritePME />} />
            <Route path="/blog/qui-est-concerne-par-nis2" element={<BlogArticleQuiEstConcerneNIS2 />} />
            <Route path="/blog/audit-cybersecurite-pme-guide-pratique" element={<BlogArticleAuditDiagnosticPME />} />
            <Route path="/blog/diagnostic-cybersecurite-a-quoi-sattendre" element={<BlogArticleDiagnosticAQuoiSattendre />} />
            <Route path="/blog/comment-evaluer-cybersecurite-pme" element={<BlogArticleCommentEvaluer />} />
            <Route path="/blog/checklist-cybersecurite-entreprise" element={<BlogArticleChecklistCybersecurite />} />
            <Route path="/blog/securite-des-donnees-rgpd" element={<BlogArticleSecuriteDonneesRGPD />} />
            <Route path="/blog/gestion-des-risques-cybersecurite-methode-commune" element={<BlogArticleGestionDesRisques />} />
            <Route path="/blog/nis2-pme-ce-qui-change" element={<BlogArticleNIS2PMEChangements />} />
            <Route path="/blog/iso27001-pme-accessible" element={<BlogArticleISO27001PMEAccessible />} />
            <Route path="/blog/ransomware-entreprise-comprendre-se-proteger" element={<BlogArticleRansomware />} />
            <Route path="/blog/phishing-entreprise-reconnaitre-prevenir" element={<BlogArticlePhishing />} />
            <Route path="/blog/que-faire-apres-cyberattaque" element={<BlogArticleQueFaireApresCyberattaque />} />
            <Route path="/blog/erreurs-cybersecurite-frequentes-pme" element={<BlogArticleErreursFrequentes />} />
            <Route path="/blog/securite-informatique-entreprise-fondamentaux" element={<BlogArticleSecuriteInformatiqueFondamentaux />} />
            <Route path="/blog/rgpd-cybersecurite-ce-que-toute-entreprise-doit-savoir" element={<BlogArticleRGPDPilier />} />
            <Route path="/blog/violation-donnees-personnelles-obligations-procedure" element={<BlogArticleViolationDonnees />} />
            <Route path="/blog/audit-rgpd-entreprise-comment-realiser" element={<BlogArticleAuditRGPD />} />
            <Route path="/blog/audit-nis2-comment-preparer-entreprise" element={<BlogArticleAuditNIS2 />} />
            <Route path="/blog/ia-risque-cybersecurite-entreprise" element={<BlogArticleIAPilier />} />
            <Route path="/blog/risques-ia-panorama" element={<BlogArticleRisquesIAPanorama />} />
            <Route path="/blog/gouvernance-systemes-ia-entreprise" element={<BlogArticleGouvernanceIA />} />
            <Route path="/blog/risques-donnees-ia-entreprise" element={<BlogArticleRisquesDonneesIA />} />
            <Route path="/blog/ai-act-cybersecurite-entreprise" element={<BlogArticleAIActCybersecurite />} />
            <Route path="/blog/attaques-systemes-ia" element={<BlogArticleAttaquesSystemesIA />} />
            <Route path="/blog/prompt-injection-comprendre-proteger" element={<BlogArticlePromptInjection />} />
            <Route path="/blog/fuite-donnees-systemes-ia" element={<BlogArticleFuiteDonneesSystemesIA />} />
            <Route path="/blog/securite-api-modeles-ia" element={<BlogArticleSecuriteAPIModelesIA />} />
            <Route path="/blog/gestion-fournisseurs-ia" element={<BlogArticleGestionFournisseursIA />} />
            <Route path="/blog/evaluer-risques-ia-methode" element={<BlogArticleEvaluerRisquesIA />} />
            <Route path="/blog/integrer-ia-iso27001" element={<BlogArticleIntegrerIAISO27001 />} />
            <Route path="/blog/ia-rgpd-nis2-articuler" element={<BlogArticleIARGPDNIS2Articuler />} />
            <Route path="/blog/supervision-usages-ia-entreprise" element={<BlogArticleSupervisionUsagesIA />} />

            {/* ROUTES PROTÉGÉES */}
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/parametres" element={<PrivateRoute><Parametres /></PrivateRoute>} />
            <Route path="/audit" element={<PrivateRoute><Audit /></PrivateRoute>} />
            <Route path="/score" element={<PrivateRoute><Score /></PrivateRoute>} />
            <Route path="/ai" element={<PrivateRoute><AssistantIA /></PrivateRoute>} />
          </Routes>
        </div>

        {/* FOOTER CONDITIONNEL */}
        <FooterWrapper />
      </div>
    </Router>
  );
}

export default App;